import React from "react";
import { ChevronRightIcon } from "lucide-react";
import Message from "../../../../i18n/Message";
import PlaygroundTabs from "../playgroundTabs";
import "./NavigationTabs.scss";
import { useUiMode } from "../context/UiModeContext";

const NavigationTabs = ({ tab, onChange, showLiveChat = false }) => {
  const { uiMode } = useUiMode();

  return (
    <div className={`navigation_tabs tab_group ${uiMode.toLowerCase()}_mode`}>
      <div
        className={
          "tab_group_item " + (tab === PlaygroundTabs.ABOUT ? "selected" : "")
        }
        onClick={() => onChange(PlaygroundTabs.ABOUT)}
      >
        {/*<<InfoIcon size={18} />*/}
        <Message id="widget_tabs_learn" />
      </div>
      <div className="separator">
        <ChevronRightIcon />
      </div>
      <div
        className={
          "tab_group_item " +
          (tab === PlaygroundTabs.EXAMPLES ? "selected" : "")
        }
        onClick={() => onChange(PlaygroundTabs.EXAMPLES)}
      >
        {/*<MessageSquareTextIcon size={18} />*/}
        <Message id="widget_tabs_examples" />
      </div>
      {showLiveChat && (
        <>
          <div className="separator">
            <ChevronRightIcon />
          </div>
          <div
            className={
              "tab_group_item " +
              (tab === PlaygroundTabs.LIVE_CHAT ? "selected" : "")
            }
            onClick={() => onChange(PlaygroundTabs.LIVE_CHAT)}
          >
            <Message id="widget_tabs_live_chat" />
          </div>
        </>
      )}
      <div className="separator">
        <ChevronRightIcon />
      </div>
      <div
        className={
          "tab_group_item " + (tab === PlaygroundTabs.CONNECT ? "selected" : "")
        }
        onClick={() => onChange(PlaygroundTabs.CONNECT)}
      >
        {/*<<PlugIcon size={18} />*/}
        <Message id="widget_tabs_connect" />
      </div>
    </div>
  );
};

export default NavigationTabs;
